// TIP 这里定义所有  异步初始化state  的名称，即定义actions中方法的名称
export const actionTypes = {
  GET_USERINFO_ACTION: 'GET_USERINFO_ACTION', // 用户信息
  // GET_BASE_COIN_ACTION: 'GET_BASE_COIN_ACTION', // 基础货币
  GET_LANGS_ACTION: 'GET_LANGS_ACTION', // 语言
  GET_CURRENCIES_ACTION: 'GET_CURRENCIES_ACTION', // 法币
  GET_ALL_COIN_ACTION: 'GET_ALL_COIN_ACTION',
  GET_ASSETS_ACTION: 'GET_ASSETS_ACTION',
  GET_MARKETLIST_ACTION: 'GET_MARKETLIST_ACTION', // 市场
  CLEAR_USERINFO_ACTION: 'CLEAR_USERINFO_ACTION', // 清除，用户信息
  GET_COIN_LIST_ACTION: 'GET_COIN_LIST_ACTION', // 获取，所有币种，列表
  GET_TRADING_PAIRS_LIST_ACTION: 'GET_TRADING_PAIRS_LIST_ACTION', // 获取，所有币币交易对，列表
  GET_USER_VIP_ACTION: 'GET_USER_VIP_ACTION',
  GET_WECHAT_QRCODE_ACTION: 'GET_WECHAT_QRCODE_ACTION',
  GET_AFFILIATE_PARTNER_INFO_ACTION: 'GET_AFFILIATE_PARTNER_INFO_ACTION',
  GET_PARTNER_INFO_ACTION: 'GET_PARTNER_INFO_ACTION',
  GET_PARTNER_TYPE_ACTION: 'GET_PARTNER_TYPE_ACTION',
  GET_AFFILIATE_TYPE_ACTION: 'GET_AFFILIATE_TYPE_ACTION',
  GET_REWARD_CATEGORIES_ACTION: 'GET_REWARD_CATEGORIES_ACTION',
};
